import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';

declare global {
  interface Window {
    __project: {
      config: any;
      env: any;
    };
  }
}

const loadConfig = () => {
  // const domain = new URL('https://ticketnow.cl').hostname; // Test
  const domain = new URL(window.location.origin).hostname;
  // if(domain.includes('localhost')) {
  //   return Promise.resolve();
  // }

  const parts = domain.split('.');
  let projectName = parts[0];
  if(projectName === 'www') {
    projectName = parts[1];
  }

  return new Promise((resolve) => {
    const script = document.createElement('script');
    // script.src = `https://ticketnow.cl/projects/${projectName}.js?t=${Date.now()}`; // Test
    script.src = `projects/${projectName}.js?t=${Date.now()}`;
    script.onload = resolve;
    script.onerror = resolve;
    document.head.appendChild(script);
  });
};

loadConfig().then(() => {
  // Crear la configuración después de cargar el script
  const appConfig = createAppConfig();

  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});
